module.exports = __webpack_public_path__ + "img/cnc_table.f18640bc.jpeg";